// Lucide icon: circle-x (https://lucide.dev/icons/circle-x)
import { CircleX } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconError = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CircleX />
    </IconComponentStyled>
  )
}
